import {
  CollectionIcon,
  css,
  FormField,
  ListItem,
  Notes,
  NumericStepper,
  SelectInput,
  styled,
} from 'canoe';
import React from 'react';

import { CollectionItem, CollectionSelectorImplProps } from './types';

export const PopoverTitle = styled(Notes)`
  ${({ theme }) => css`
    color: ${theme.colors.White};
    margin: 0 0 ${theme.spaces.xs} 0;
  `}
`;

const StepperWrapper = styled.div`
  width: min-content;
  display: flex;
  align-items: center;
`;

const Container = styled.div`
  ${({ theme }) => css`
    label {
      color: ${theme.colors.White};
    }
  `}
`;

export const CollectionSelectorToolbar: React.FC<CollectionSelectorImplProps> = React.memo(
  ({
    collectionId,
    onChangeSource,
    items,
    maxRecords,
    onChangeMaxRecords,
  }: CollectionSelectorImplProps) => {
    return (
      <Container>
        <PopoverTitle>Connect to a collection</PopoverTitle>
        <FormField data-cy="select-row" label="" scale="small">
          <SelectInput<CollectionItem>
            renderValue={({ selectedItem, ...selectedItemProps }) => (
              <ListItem
                prefix={<CollectionIcon size="s" color="OnyxGrayL10" />}
                {...selectedItemProps}
              >
                {selectedItem?.label}
              </ListItem>
            )}
            selectedItem={items.find(({ value }) => collectionId === value)}
            items={items}
            onSelect={onChangeSource}
            placeholder="Select a collection"
          />
        </FormField>

        {collectionId && (
          <FormField data-cy="records-row" label="Records displayed" scale="small">
            <StepperWrapper>
              <NumericStepper
                scale="small"
                value={maxRecords}
                name="records"
                valueSuffix="/20 max"
                editable
                format="contained"
                maxValue={20}
                minValue={1}
                step={1}
                onChange={onChangeMaxRecords}
              />
            </StepperWrapper>
          </FormField>
        )}
      </Container>
    );
  },
);
